var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-text-body-xs-bold lg:fe-text-body-m-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }